import React, { useState, useEffect } from 'react';
import moment from 'moment';
import axios from 'axios';
import Select from 'react-select';
import { truncate } from 'lodash';
import FroalaEditor from 'react-froala-wysiwyg'; // Components

import { TagsInput } from "../../components/Autocomplete";
import Attachment, { confirmDelete } from "../../components/Attachment"; // Global States for faster scheduling

import { useStore } from "../../contexts/store"; // API

import { employeeApi, fileApi } from '@atheneum/api'; // Helpers

import formatDateTime from "../../helpers/zoomHelpers/formatDateTime";
import formatExpertInvite, { validateAdditionalEmails } from "../../helpers/expertHelpers";
import updateSchedule from "../../helpers/scheduleHelpers/updateSchedule";
export const SendInviteExpert = ({
  eplModel
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isToolboxClosing] = useState(false);
  const [isToolboxClosed] = useState(true);
  const {
    state,
    dispatch
  } = useStore();
  const {
    availabilityStore_imp,
    expertMessage,
    schedule,
    zoomLocationExpert,
    activeTeams,
    selectedTeam,
    additionalEmailsExpert,
    expertSubject,
    showSkipExpert,
    lastPath,
    quickInviteExpert,
    templates,
    zoomNum,
    selectedLanguage,
    employeeSubmitted,
    expertTimezoneName,
    timezoneTranslated,
    expertCountry,
    expertInvited,
    meetingType,
    languageUpdated,
    previouslySend,
    templateId,
    previouslySendLanguage,
    typeUpdated,
    expertDayOffset,
    locationExpert,
    showExpertCountry,
    opsTime,
    dayToRender,
    duration
  } = state;

  const getExpertText = () => {
    return formatExpertInvite(expertMessage, schedule, availabilityStore_imp, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry).replaceAll('contenteditable="false"', `contenteditable="false" class='unEditbaleInvite'`);
  };

  const [expertText, setExpertText] = useState(getExpertText()); // Update schedule with the latest value when opsTime(timebar on ui) changes

  useEffect(() => {
    if (opsTime) {
      const {
        newTimeslot,
        newAvailabilities
      } = updateSchedule(dayToRender, opsTime, duration);
      dispatch({
        type: 'SETSCHEDULE',
        payload: {
          schedule: { ...schedule,
            timeslots: [newTimeslot],
            availabilities: [...schedule.availabilities, ...newAvailabilities]
          }
        }
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [opsTime]); // Update expertText for invite whenever information that expertText depends on changes

  useEffect(() => {
    setExpertText(getExpertText()); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expertInvited, expertMessage, schedule, schedule.timeslots, availabilityStore_imp, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry]);
  const [attachments, setAttachments] = useState(eplModel.details && eplModel.details.attachments || []);

  const handleAttachments = obj => setAttachments(obj);

  const {
    EMPLOYEE_POSITIONS
  } = availabilityStore_imp.staticData.CONST;
  const employeePositions = [EMPLOYEE_POSITIONS.ASSOCIATE, EMPLOYEE_POSITIONS.TEAM_LEADER, EMPLOYEE_POSITIONS.ACCOUNT_MANAGER, EMPLOYEE_POSITIONS.PRINCIPAL];

  const onFocus = () => {
    setIsFocused(true);
  };

  const onBlur = () => {
    setIsFocused(false);
  };

  const focused = isFocused ? 'rich-text-wrapper--focused rich-text-wrapper--toolboxActive' : '';
  const config = {
    key: process.env.REACT_APP_FROALA_KEY,
    quickInsertTags: [],
    charCounterCount: false,
    linkInsertButtons: [],
    toolbarButtons: ['paragraphFormat', '|', 'formatOL', 'formatUL', '|', 'insertLink', '|', 'clearFormatting', 'underline', 'italic', 'bold'],
    htmlAllowedStyleProps: ['text-align', 'font-size', 'width', 'height', 'vertical-align', 'font-weight', 'font-style', 'text-decoration', 'display', 'direction', 'letter-spacing', 'word-spacing'],
    events: {
      'froalaEditor.focus': onFocus,
      'froalaEditor.blur': onBlur
    },
    linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
    isFocused: true,
    isToolboxClosing: isToolboxClosing,
    isToolboxClosed: isToolboxClosed
  };
  const initExpertText = getExpertText();

  const translate = async (string, language) => {
    return await axios({
      url: `${process.env.REACT_APP_TRANSLATE_URL}?q=${string}&t=${language}&s=en`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        authorization: window.localStorage.getItem('ngStorage-accessToken')
      }
    });
  };

  const mcKinseyNames = {
    '[CN] mck_schedule_invite_wh': 'chinese',
    '[ES] mck_schedule_invite_wh': 'spanish',
    '[RU] mck_schedule_invite_wh': 'russian',
    '[DE] mck_schedule_invite_wh': 'german',
    '[FR] mck_schedule_invite_wh': 'french',
    '[IT] mck_schedule_invite_wh': 'italian',
    '[KR] mck_schedule_invite_wh': 'korean',
    '[PT] mck_schedule_invite_wh': 'portuguese',
    '[EN] mck_schedule_invite_wh': 'english',
    '[PL] mck_schedule_invite_wh': 'polish',
    '[CN] mck_schedule_invite': 'chinese',
    '[ES] mck_schedule_invite': 'spanish',
    '[RU] mck_schedule_invite': 'russian',
    '[DE] mck_schedule_invite': 'german',
    '[FR] mck_schedule_invite': 'french',
    '[IT] mck_schedule_invite': 'italian',
    '[KR] mck_schedule_invite': 'korean',
    '[PT] mck_schedule_invite': 'portuguese',
    '[EN] mck_schedule_invite': 'english',
    '[PL] mck_schedule_invite': 'polish',
    '[JP] mck_schedule_invite': 'japanese'
  };
  const languages = {
    chinese: 'zhTW',
    spanish: 'es',
    russian: 'ru',
    german: 'de',
    french: 'fr',
    italian: 'it',
    korean: 'ko',
    portuguese: 'pt',
    english: 'en',
    polish: 'pl',
    japanese: 'ja'
  };

  const handleChange = async e => {
    e.persist();
    dispatch({
      type: 'UPDATE',
      payload: {
        renderSpinner: true,
        // @ts-ignore
        languageUpdated: truncate
      }
    });

    if (Object.keys(languages).includes(e.target.value.toLowerCase()) || Object.keys(mcKinseyNames).includes(e.target.value)) {
      const newId = templates.filter(t => t.name.toLowerCase() === e.target.value.toLowerCase())[0].id;
      const selectedTemplate = [...templates].filter(template => template.name === e.target.value)[0];
      const isMcKinsey = meetingType === 'mcKinsey';
      dispatch({
        type: 'UPDATE',
        payload: {
          selectedLanguage: isMcKinsey ? mcKinseyNames[e.target.value] : e.target.value.toLowerCase(),
          selectedTemplate: selectedTemplate,
          templateId: newId
        }
      });
      const country = await translate(expertCountry, isMcKinsey ? languages[mcKinseyNames[e.target.value]] : languages[e.target.value.toLowerCase()]);
      const timezone = await translate(expertTimezoneName, isMcKinsey ? languages[mcKinseyNames[e.target.value]] : languages[e.target.value.toLowerCase()]);
      const formattedExpertInvite = formatExpertInvite(selectedTemplate.content, schedule, availabilityStore_imp, zoomNum, employeeSubmitted, isMcKinsey ? mcKinseyNames[e.target.value] : e.target.value.toLowerCase(), country.data.TranslatedText, expertTimezoneName, timezone.data.TranslatedText, languageUpdated, newId, previouslySendLanguage, expertDayOffset, showExpertCountry).replaceAll('contenteditable="false"', `contenteditable="false" class='unEditbaleInvite'`);
      setExpertText(formattedExpertInvite);
    } else {
      setExpertText(previouslySend.replaceAll('contenteditable="false"', `contenteditable="false" class='unEditbaleInvite'`));
      dispatch({
        type: 'UPDATE',
        payload: {
          languageUpdated: false
        }
      });
    }

    return dispatch({
      type: 'UPDATE',
      payload: {
        renderSpinner: false
      }
    });
  };

  const additionalEmailsValid = !(additionalEmailsExpert && additionalEmailsExpert.find(email => email.invalid));
  const formIsValid = Boolean(additionalEmailsValid && selectedTeam);
  return employeeSubmitted.length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, "Invite Expert "), /*#__PURE__*/React.createElement("hr", {
    className: "hr-separator hr-separator--light hr-separator--large-margin"
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section  request-schedule__invite-info"
  }, "A zoom meeting has not been created yet until you click confirm. You can update the email in this window to update the inventation's default before sending it out"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Team"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "invite-expert__note"
  }, "Make sure to select your team, the event will be added to team calendar!"), /*#__PURE__*/React.createElement(Select, {
    classNamePrefix: "teamInput",
    defaultValue: selectedTeam,
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        selectedTeam: e
      }
    }),
    options: activeTeams
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: selectedTeam ? 'none' : 'flex'
    }
  }, "A team must be selected to continue."))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "To Expert"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, availabilityStore_imp.epl.expert.title, ' ', availabilityStore_imp.epl.expert.fullName, ":", ' ', /*#__PURE__*/React.createElement("strong", null, availabilityStore_imp.epl.expert.email))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "To additional emails"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer",
    style: {
      lineHeight: '24px'
    }
  }, /*#__PURE__*/React.createElement(TagsInput, {
    value: additionalEmailsExpert,
    creatable: true,
    placeholder: "Type or select company",
    itemToString: item => item.fullName,
    itemFromCreatable: email => validateAdditionalEmails(email),
    loadOptions: query => employeeApi.typeaheadSearch(employeePositions, query),
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        additionalEmailsExpert: e
      }
    }),
    debounce: 500
  }), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: additionalEmailsValid ? 'none' : 'flex'
    }
  }, "All additional contacts must include a valid email address."))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Subject"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    className: "expert-form__input",
    name: "expertInvite",
    value: expertSubject,
    onChange: e => dispatch({
      type: 'UPDATE',
      payload: {
        expertSubject: e.target.value
      }
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Location"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, /*#__PURE__*/React.createElement("input", {
    className: "expert-form__input",
    name: "expertInvite",
    value: meetingType !== 'Zoom' ? locationExpert : zoomLocationExpert,
    onChange: e => {
      const dataToUpdate = {};

      if (meetingType === 'Zoom') {
        dataToUpdate.zoomLocationClient = e.target.value;
      } else {
        dataToUpdate.locationClient = e.target.value;
      }

      dispatch({
        type: 'UPDATE',
        payload: {
          zoomLocationClient: e.target.value
        }
      });
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Starts on"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, formatDateTime(schedule.timeslots[0].time.start))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Ends on"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, formatDateTime(schedule.timeslots[0].time.start + 1000 * 60 * schedule.timeslots[0].duration))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Language"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper expert-form__input-wrapper--label inputLabelColer"
  }, /*#__PURE__*/React.createElement("select", {
    id: "handleTemplateType",
    onChange: handleChange,
    style: {
      height: '36px'
    },
    className: "selectMeetingType"
  }, templates.map(template => /*#__PURE__*/React.createElement("option", {
    selected: meetingType === 'mcKinsey' ? mcKinseyNames[template.name] === selectedLanguage.toLowerCase() : template.name.toLowerCase() === selectedLanguage.toLowerCase() && (!expertInvited || typeUpdated),
    key: template.id,
    value: template.name
  }, meetingType === 'mcKinsey' ? mcKinseyNames[template.name] : template.name)), !typeUpdated && expertInvited && /*#__PURE__*/React.createElement("option", {
    key: 0,
    selected: !languageUpdated,
    value: expertMessage
  }, "Previously Sent")))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("label", {
    className: "expert-form__label"
  }, "Message"), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${isFocused ? 'rich-text-wrapper--focused rich-text-wrapper--toolboxActive' : ''} left-text rich-text-wrapper `
  }, /*#__PURE__*/React.createElement("div", {
    className: `left-text rich-text-wrapper ${focused}`
  }, /*#__PURE__*/React.createElement(FroalaEditor, {
    tag: "textarea",
    config: config,
    model: expertText,
    onModelChange: value => setExpertText(value)
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__input-group",
    style: {
      borderTop: '1px solid #e5e5e5',
      paddingTop: '23px'
    }
  }, /*#__PURE__*/React.createElement(Attachment, {
    tooltip: "Click to add attachments",
    label: "Add attachment",
    url: `/api/expert-project-link/${availabilityStore_imp.epl.id}/attachments`,
    onOk: async () => {
      await eplModel.getDetails();
      handleAttachments(eplModel.details.attachments);
    },
    onDelete: fileId => confirmDelete(fileId, fileApi.deleteFile).then(async () => {
      await eplModel.getDetails();
      handleAttachments(eplModel.details.attachments);
    }),
    attachments: attachments
  })), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__section"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '10px'
    }
  }, "This is a calendar invite for the expert. ", /*#__PURE__*/React.createElement("br", null), "Your calendar will be updated as well."))), /*#__PURE__*/React.createElement("div", {
    className: "expert-form__section",
    style: {
      padding: '0px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__controls__inner"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button button--primary fullOnMobile responsiveMargin",
    onClick: () => {
      // must select a team to continue
      if (!formIsValid) return;
      dispatch({
        type: 'UPDATE',
        payload: {
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          },
          expertinviteEdited: 'expert',
          lastPath: '',
          currentPath: lastPath,
          inviteExpert: true,
          quickInviteExpert: !quickInviteExpert,
          expertMessage: expertText.replaceAll(`contenteditable="false" class='unEditbaleInvite'`, 'contenteditable="false"'),
          expertMessageUpdated: initExpertText !== expertText,
          ExpertOffsetSet: false
        }
      });
    }
  }, "Send calendar invitation"), showSkipExpert && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button button--secondary fullOnMobile",
    onClick: async () => {
      if (!formIsValid) return;
      dispatch({
        type: 'UPDATE',
        payload: {
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          },
          expertinviteEdited: 'expert',
          lastPath: '',
          currentPath: lastPath,
          skipInviteExpert: true,
          inviteExpert: true,
          quickInviteExpert: !quickInviteExpert,
          expertMessage: expertText.replaceAll(`contenteditable="false" class='unEditbaleInvite'`, 'contenteditable="false"'),
          ExpertOffsetSet: false
        }
      });
    }
  }, "Only add to team calendar")), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "button button--secondary button button--secondary",
    onClick: () => {
      if (!formIsValid) return;
      dispatch({
        type: 'UPDATE',
        payload: {
          expertZone: {
            timezoneOffset: moment().utcOffset(moment.tz.guess()).utcOffset(),
            displayLabel: 'Expert'
          },
          ExpertOffsetSet: false,
          currentPath: lastPath,
          lastPath: '',
          quickUpdateExpert: false,
          expertinviteEdited: '',
          quickInviteExpert: false,
          expertInvited: false
        }
      });
    }
  }, "Skip calendar invitation"))), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: selectedTeam ? 'none' : 'flex'
    }
  }, "A team must be selected to continue."), /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__section request-schedule__team-select-error",
    style: {
      display: additionalEmailsValid ? 'none' : 'flex'
    }
  }, "All additional contacts must include a valid email address."));
};